export default __webpack_public_path__ + "0077fd01c0cd341ba73d67a27256bf80.png";